<template>
  <div :class="{ 'h5-refound-list': isH5 }">
    <div v-if="list.length">
      <component
        :is="handleRefundItem"
        @showRefundDetail="showRefundDetail"
        @showUseDetail="showUseDetail"
        v-for="item in list"
        :key="item.refund_order_no"
        :refundInfo="item"
      />
      <el-pagination
        class="page-wrap"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pageInfo.page"
        :total="pageInfo.total"
        :page-sizes="[10, 15, 20, 30]"
        @size-change="handleSizeChange"
        @current-change="handleChangePage"
      />
    </div>
    <!-- 空列表 -->
    <el-empty
      v-else
      style="height: 400px"
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
    <course-usage
      :visible="courseUsageVisible"
      :data="currentGoods"
      type="refund"
      @close="courseUsageVisible = false"
    />
    <refund-dialog
      :visible="refundDialogVisible"
      :data="currentGoods"
      :type="type"
      @close="refundDialogVisible = false"
    />
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import MobileRefundItem from "./MobileRefundItem.vue";
import RefundItem from "./RefundItem";
import { getRefundList } from "@saas/service-api/src/learning-center";
import { CourseUsage } from "@saas/components/src";
import { RefundDialog } from "@saas/components/src";
import formatTime from "@saas/components/src/utils/filters.js";
export default {
  name: "Refund",
  components: {
    CourseUsage,
    RefundDialog,
    RefundItem,
    MobileRefundItem,
  },
  data() {
    return {
      loading: false,
      statistics: {},
      list: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      courseUsageVisible: false,
      refundDialogVisible: false,
      currentGoods: {},
      type: 0,
      parseTime: formatTime.formatSelfTime,
      isH5: false,
    };
  },
  computed: {
    handleRefundItem() {
      return this.isH5 ? MobileRefundItem : RefundItem;
    },
    handlePermission() {
      const roleKeys = ["Owner", "SuperAdmin", "CourseAdmin"];
      return roleKeys.includes(
        this.$store.state.user?.userInfo?.role_key || ""
      );
    },
  },

  mounted() {
    this.isH5 = isH5();
    this.getList();
  },
  methods: {
    formatPrice(val) {
      if (val) {
        return "￥" + (val / 100).toFixed(2);
      } else {
        return "-";
      }
    },
    formatTime(row, column, cellValue) {
      if (!cellValue) {
        return "-";
      } else {
        return this.parseTime(cellValue, "YYYY-MM-DD HH:mm:ss");
      }
    },
    // 手机号隐藏中间4位
    formatPhone(phone) {
      if (phone) {
        return String(phone).substr(0, 3) + "****" + String(phone).substr(7);
      } else {
        return "";
      }
    },
    dealValidityType(item) {
      if (item.validity_type === 1) {
        return `${this.parseTime(
          item.course_start_time,
          "YYYY-MM-DD HH:mm:ss"
        )} - ${this.parseTime(item.course_end_time, "YYYY-MM-DD HH:mm:ss")}`;
      } else if (item.validity_type === 2) {
        // 结束时间减去开始时间，判断多少天
        const endTime = item.course_end_time;
        const startTime = item.course_start_time;
        const day = (endTime - startTime) / (24 * 60 * 60);
        return `随到随学（${day}）天`;
      } else {
        return "永久有效";
      }
    },

    getList() {
      getRefundList({
        page_no: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
      })
        .then((res) => {
          const { code, data, message } = res;
          if (code === 1) {
            this.list = data.list || {};
            this.pageInfo.total = data.total;
          } else {
            this.$message.error(message);
          }
        })
        .catch((err) => {
          console.error("获取订单列表失败>>>", err);
        });
    },
    // 使用详情
    showUseDetail(row) {
      this.currentGoods = row;
      this.courseUsageVisible = true;
    },
    handleChangePage(page) {
      this.pageInfo.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.getList();
    },
    // 退款详情
    showRefundDetail(row) {
      // 拼团退款
      if (row.reply_result === 2 && [2, 3].includes(row.refund_way)) {
        let msg =
          row.refund_way === 2
            ? "待成团时取消拼团，系统自动退款。"
            : "拼团失败，系统自动退款。";
        this.$confirm(msg, "退款详情", {
          showCancelButton: false,
          confirmButtonText: "关闭",
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
        })
          .then(() => {})
          .catch(() => {});
      } else {
        this.currentGoods = row;
        this.type = 3;
        this.refundDialogVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 溢出隐藏
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 调整这里的数值以适应需要显示的行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.page-wrap {
  padding: 25px 0;
  text-align: right;
}
::v-deep .el-pagination {
  .el-pagination__total {
    font-size: 12px;
    color: #1d2129;
  }
  .el-select .el-input .el-input__inner {
    background: #f2f3f5;
    border-radius: 6px;
    border: none;
    font-size: 12px;
    color: #1d2129;
  }
  .el-pagination__editor.el-input .el-input__inner {
    background: #f2f3f5;
    border-radius: 6px;
    border: none;
    font-size: 12px;
    color: #1d2129;
  }
  .el-pager li {
    min-width: 28px;
    background: #f7f8fa;
    border-radius: 6px;
    padding: 0;
    margin: 0 5px;
    font-weight: 400;
    font-size: 12px;
  }
  .el-pager li.active {
    background: #e5faf5;
    color: $saas-theme-color;
    font-weight: 400;
    font-size: 12px;
  }
  .el-pagination .btn-prev,
  .btn-next {
    padding: 0 5px;
    min-width: 28px;
    margin: 0 5px;
    background: #f7f8fa;
    border-radius: 6px;
  }
}

.h5-refound-list {
  ::v-deep .el-pagination {
    display: flex;
    flex-wrap: wrap;
    .el-pagination__total {
      margin-left: 10px;
      margin-bottom: 8px;
    }
    .el-pagination__sizes {
      width: calc(100% - 90px);
      text-align: left;
      margin-bottom: 8px;
    }
    .el-pagination__jump {
      width: 100%;
      text-align: left;
      margin-left: 10px;
      margin-top: 8px;
    }
  }
}
</style>
